import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import { ApiTypes, CroppingSuitabilityModel } from "@agroyaar/sdk";
import { getFarmerId } from "@new-services/utils/getFarmerId";
import { useCroppingSuitability } from "@new-services/services";
import CroppingSuitabilityReportPage from "@/features/reports/presentation/components/cropping-suitability-single-product/components/CroppingSuitabilityReportPage";

const CroppingSuitabilitySingleProduct = () => {
  const { id } = useParams();
  const [croppingSuitability, setCroppingSuitability] =
    useState<CroppingSuitabilityModel>();

  const mechanizationVariables: ApiTypes.CroppingSuitability["RequestParams"]["getOne"] =
    useMemo(
      () => ({
        pathParams: {
          croppingSuitabilityId: id!,
          farmerId: getFarmerId()!,
        },
      }),
      [id]
    );

  const croppingSuitabilityQuery = useCroppingSuitability(
    mechanizationVariables
  );

  useEffect(() => {
    if (croppingSuitabilityQuery.data) {
      setCroppingSuitability(croppingSuitabilityQuery.data);
    }
  }, [croppingSuitabilityQuery.data]);

  return (
    <div>
      {croppingSuitabilityQuery.isLoading ||
      !croppingSuitabilityQuery.data?.reports.length ? (
        <div>
          <Spin
            size="large"
            className="flex justify-center h-60 items-center !text-purple-950"
          />
          <p className="flex justify-center items-center">
            در حال آماده‌سازی گزارش
          </p>
          <span className="flex justify-center mt-10 text-sm">
            ممکن است پردازش اطلاعات شما دقایقی زمان ببرد، لطفا منتظر بمانید...
          </span>
        </div>
      ) : (
        <CroppingSuitabilityReportPage
          croppingSuitability={croppingSuitability}
          isLoading={croppingSuitabilityQuery.isLoading}
        />
      )}
    </div>
  );
};

export default CroppingSuitabilitySingleProduct;
